import createDocumentSlice from "./createDocumentSlice";
import { config } from "../../utils/apiUrl";

/*
|--------------------------------------------------------------------------
| DELIVERY CHALLAN MODULE
|--------------------------------------------------------------------------
*/

const deliveryChallanModule =
  createDocumentSlice({
    sliceName:
      "deliveryChallan",

    stateKey:
      "deliveryChallan",

    documentName:
      "Delivery Challan",

    documentType:
      "DELIVERY_CHALLAN",

    documentKey:
      "deliveryChallan",

    documentKeys: [
      "sourceDeliveryChallan",
    ],

    listKey:
      "deliveryChallans",

    urls: {
      list:
        config.getDeliveryChallans,

      summary:
        config.getDeliveryChallanSummary,

      createData:
        config.getDeliveryChallanCreateData,

      dropdowns:
        config.getDeliveryChallanDropdowns,

      getById:
        config.getDeliveryChallanById,

      create:
        config.createDeliveryChallan,

      update:
        config.updateDeliveryChallan,

      confirm:
        config.confirmDeliveryChallan,

      cancel:
        config.cancelDeliveryChallan,

      duplicate:
        config.duplicateDeliveryChallan,

      convert:
        config.convertDeliveryChallan,

      delete:
        config.deleteDeliveryChallan,

      history:
        config.getDeliveryChallanHistory,
    },

    initialFilters: {
      paymentStatus:
        "",

      fulfillmentStatus:
        "",

      conversionStatus:
        "",
    },

    initialSummary: {
      notFulfilledCount:
        0,

      partiallyFulfilledCount:
        0,

      fulfilledCount:
        0,
    },

    initialDropdowns: {
      documentStatuses:
        [],

      fulfillmentStatuses:
        [],

      conversionStatuses:
        [],

      conversionTargets:
        [],

      deliveryTypes:
        [],

      salesChannels:
        [],

      priceModes:
        [],
    },

    supportsConfirm:
      true,

    supportsCancel:
      true,

    supportsDuplicate:
      true,

    supportsConvert:
      true,

    supportsDelete:
      true,

    supportsHistory:
      true,
  });

/*
|--------------------------------------------------------------------------
| REDUCER
|--------------------------------------------------------------------------
*/

export default
  deliveryChallanModule.reducer;

/*
|--------------------------------------------------------------------------
| ACTIONS
|--------------------------------------------------------------------------
*/

export const {
  setFilters:
    setDeliveryChallanFilters,

  setFilter:
    setDeliveryChallanFilter,

  setPage:
    setDeliveryChallanPage,

  setLimit:
    setDeliveryChallanLimit,

  resetFilters:
    resetDeliveryChallanFilters,

  setSelectedDocument:
    setSelectedDeliveryChallan,

  clearSelectedDocument:
    clearSelectedDeliveryChallan,

  clearHistory:
    clearDeliveryChallanHistory,

  clearErrors:
    clearDeliveryChallanErrors,

  clearOperation:
    clearDeliveryChallanOperation,

  clearLastCreatedDocument:
    clearLastCreatedDeliveryChallan,

  clearLastDuplicatedDocument:
    clearLastDuplicatedDeliveryChallan,

  clearLastConvertedDocument:
    clearLastConvertedDeliveryChallanDocument,

  resetState:
    resetDeliveryChallanState,
} =
  deliveryChallanModule.actions;

/*
|--------------------------------------------------------------------------
| THUNKS
|--------------------------------------------------------------------------
*/

export const {
  fetchDocuments:
    fetchDeliveryChallans,

  fetchSummary:
    fetchDeliveryChallanSummary,

  fetchCreateData:
    fetchDeliveryChallanCreateData,

  fetchDropdowns:
    fetchDeliveryChallanDropdowns,

  fetchDocumentById:
    fetchDeliveryChallanById,

  createDocument:
    createDeliveryChallan,

  updateDocument:
    updateDeliveryChallan,

  confirmDocument:
    confirmDeliveryChallan,

  cancelDocument:
    cancelDeliveryChallan,

  duplicateDocument:
    duplicateDeliveryChallan,

  convertDocument:
    convertDeliveryChallan,

  deleteDocument:
    deleteDeliveryChallan,

  fetchDocumentHistory:
    fetchDeliveryChallanHistory,
} =
  deliveryChallanModule.thunks;

/*
|--------------------------------------------------------------------------
| SELECTORS
|--------------------------------------------------------------------------
*/

export const {
  selectModule:
    deliveryChallanSelector,

  selectDocuments:
    deliveryChallanListSelector,

  selectSelectedDocument:
    selectedDeliveryChallanSelector,

  selectSummary:
    deliveryChallanSummarySelector,

  selectFilters:
    deliveryChallanFiltersSelector,

  selectPagination:
    deliveryChallanPaginationSelector,

  selectCreateData:
    deliveryChallanCreateDataSelector,

  selectDropdowns:
    deliveryChallanDropdownsSelector,

  selectHistory:
    deliveryChallanHistorySelector,

  selectLoading:
    deliveryChallanLoadingSelector,

  selectOperation:
    deliveryChallanOperationSelector,
} =
  deliveryChallanModule.selectors;